import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { CommonService, SsoService } from 'wire-frame';
import { HotkeyService } from './service/hotkey.service';
import { HotkeyHelpService } from './service/admin/hotkey-help.service';
import { HotkeyHelpComponent } from '../app/component/admin/hotkey-help/hotkey-help.component';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule, HotkeyHelpComponent, NgIf],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [HotkeyService],
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  title = 'Dr. Sancheti Homeopathy Clinic';

  private userRole: string | null = null;
  private logoObserver: MutationObserver | null = null;
  public visible = false;

  get showGlobalHotkeyHelp(): boolean {
    const path = this.router.url.split('?')[0].split('#')[0];

    if (!path.startsWith('/admin/')) {
      return false;
    }

    return !path.includes('pre-consultation')
      && !path.includes('prescriptions');
  }

  constructor(
    private common: CommonService,
    private sso: SsoService,
    private hotkeyService: HotkeyService,
    private hotkeyHelpService: HotkeyHelpService,
    public router: Router,
    private location: Location
  ) { }

  ngOnInit() {
    this.common.hideProfilesDropdown?.next(true);
    const storageUserKey = 'loggedInUser_persist';
    const token = localStorage.getItem('jwtToken');
    let sessionUserRaw = sessionStorage.getItem('loggedInUser');

    if (!sessionUserRaw && token) {
      const persistedUserRaw = localStorage.getItem(storageUserKey);
      if (persistedUserRaw) {
        sessionStorage.setItem('loggedInUser', persistedUserRaw);
        sessionUserRaw = persistedUserRaw;
      }
    }

    const loggedInUser = JSON.parse(sessionUserRaw || '{}');
    if (loggedInUser && Object.keys(loggedInUser).length) {
      localStorage.setItem(storageUserKey, JSON.stringify(loggedInUser));
    }

    this.userRole = loggedInUser?.type ?? null;

    this.registerGlobalHotkeys();
    this.configureMenus(loggedInUser);
    this.configureEnvironment();

    // Listen to route changes to re-initialize menus and hotkeys upon login without refreshing
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (!this.showGlobalHotkeyHelp) {
          this.hotkeyHelpService.close();
        }

        const currentUserRaw = sessionStorage.getItem('loggedInUser');
        const currentUser = JSON.parse(currentUserRaw || '{}');
        const newRole = currentUser?.type ?? null;

        if (newRole && newRole !== this.userRole) {
          this.userRole = newRole;
          this.registerGlobalHotkeys();
          this.configureMenus(currentUser);
        }
      }
    });
  }

  /* =========================
     KEYBOARD SHORTCUTS
     ========================= */

  // private registerGlobalHotkeys() {
  //   // ===================================================== GLOBAL (ALL ROLES) --------

  //   this.hotkeyService.addShortcut({
  //     keys: 'alt.h',
  //     description: 'Go to Dashboard',
  //   }).subscribe(() => {
  //     this.router.navigate(['/admin/dashboard']);
  //   });

  //   this.hotkeyService.addShortcut({
  //     keys: 'alt.b',
  //     description: 'Go Back',
  //   }).subscribe(() => {
  //     this.location.back();
  //   });

  //   this.hotkeyService.addShortcut({
  //     keys: 'ctrl.shift.k',
  //     description: 'DEBUG Search'
  //   }).subscribe(() => {
  //     console.log('CTRL + SHIFT + F FIRED');
  //   });

  //   // =================================================== Doctor hot keys
  //   if (this.userRole === 'doctor') {
  //     this.hotkeyService.addShortcut({
  //       keys: 'alt.a',
  //       description: 'Go to Appointments',
  //     }).subscribe(() => {
  //       this.router.navigate(['/admin/appointment']);
  //     });

  //     this.hotkeyService.addShortcut({
  //       keys: 'alt.l',
  //       description: 'Go to Appointment List',
  //     }).subscribe(() => {
  //       this.router.navigate(['/admin/appointment-list']);
  //     });

  //     this.hotkeyService.addShortcut({
  //       keys: 'alt.r',
  //       description: 'Go to Prescriptions',
  //     }).subscribe(() => {
  //       this.router.navigate(['/admin/prescriptions']);
  //     });

  //     this.hotkeyService.addShortcut({
  //       keys: 'alt.p',
  //       description: 'Go to Patient Registration',
  //     }).subscribe(() => {
  //       this.router.navigate(['/admin/patient-registration']);
  //     });

  //     this.hotkeyService.addShortcut({
  //       keys: 'alt.m',
  //       description: 'Dispense Medicine',
  //     }).subscribe(() => {
  //       this.router.navigate(['/admin/pharmacy']);
  //     });

  //     this.hotkeyService.addShortcut({
  //       keys: 'alt.shift.m',
  //       description: 'Manage Medicine',
  //     }).subscribe(() => {
  //       this.router.navigate(['/admin/medicine']);
  //     });

  //     this.hotkeyService.addShortcut({
  //       keys: 'alt.c',
  //       description: 'Certificates',
  //     }).subscribe(() => {
  //       this.router.navigate(['/admin/certificates']);
  //     });

  //     this.hotkeyService.addShortcut({
  //       keys: 'alt.f',
  //       description: 'Medicine Finder',
  //     }).subscribe(() => {
  //       this.router.navigate(['/admin/medicine-finder']);
  //     });

  //     // this.hotkeyService.addShortcut({
  //     //   keys: 'ctrl.shift.f',
  //     //   description: 'Open Patient Search'
  //     // }).subscribe(() => {
  //     //   document
  //     //     .querySelector('[data-hotkey="patient-search"]')
  //     //     ?.dispatchEvent(new CustomEvent('open-search'));
  //     // });

  //     this.hotkeyService.addShortcut({
  //       keys: 'esc',
  //       description: 'Close Sidebar / Modal'
  //     }).subscribe(() => {
  //       document
  //         .querySelector('p-sidebar .p-sidebar-close')
  //         ?.dispatchEvent(new Event('click'));
  //     });
  //   }

  //   // ============================================================= Assistant Doctor Hot keys
  //   if (this.userRole === 'assistant-doctor') {
  //     this.hotkeyService.addShortcut({
  //       keys: 'alt.m',
  //       description: 'Dispense Medicine',
  //     }).subscribe(() => {
  //       this.router.navigate(['/admin/pharmacy']);
  //     });

  //     this.hotkeyService.addShortcut({
  //       keys: 'alt.p',
  //       description: 'Go to Patient Registration',
  //     }).subscribe(() => {
  //       this.router.navigate(['/admin/patient-registration']);
  //     });

  //     this.hotkeyService.addShortcut({
  //       keys: 'alt.f',
  //       description: 'Medicine Finder',
  //     }).subscribe(() => {
  //       this.router.navigate(['/admin/medicine-finder']);
  //     });

  //     this.hotkeyService.addShortcut({
  //       keys: 'alt.c',
  //       description: 'Certificates',
  //     }).subscribe(() => {
  //       this.router.navigate(['/admin/certificates']);
  //     });
  //   }

  //   // ============================================================= Reception Hot keys
  //   if (this.userRole === 'reception') {
  //     this.hotkeyService.addShortcut({
  //       keys: 'alt.l',
  //       description: 'Appointment List',
  //     }).subscribe(() => {
  //       this.router.navigate(['/admin/appointment-list']);
  //     });

  //     this.hotkeyService.addShortcut({
  //       keys: 'alt.p',
  //       description: 'Patient Registration',
  //     }).subscribe(() => {
  //       this.router.navigate(['/admin/patient-registration']);
  //     });

  //     this.hotkeyService.addShortcut({
  //       keys: 'alt.m',
  //       description: 'Dispense Medicine',
  //     }).subscribe(() => {
  //       this.router.navigate(['/admin/pharmacy']);
  //     });

  //     this.hotkeyService.addShortcut({
  //       keys: 'alt.c',
  //       description: 'Certificates',
  //     }).subscribe(() => {
  //       this.router.navigate(['/admin/certificates']);
  //     });
  //   }

  //   // ============================================================= Pharmacy hot keys
  //   if (this.userRole === 'pharmacy') {
  //     this.hotkeyService.addShortcut({
  //       keys: 'alt.shift.m',
  //       description: 'Manage Medicine',
  //     }).subscribe(() => {
  //       this.router.navigate(['/admin/medicine']);
  //     });
  //   }
  // }

  private registerGlobalHotkeys() {

    //! ========================= GLOBAL (ALL ROLES)

    this.hotkeyService.addShortcut(
      'alt.h',
      () => this.router.navigate(['/admin/dashboard']),
      'Go to Home Page'
    );

    // this.hotkeyService.addShortcut(
    //   'alt.b',
    //   () => this.location.back(),
    //   'Go Back'
    // );

    this.hotkeyService.addShortcut(
      'control./',
      () => this.hotkeyHelpService.toggle(),
      'Show Keyboard Shortcuts',
      true
    );

    //! ========================= DOCTOR

    if (this.userRole === 'doctor') {

      this.hotkeyService.addShortcut(
        'control.shift.f',
        () => {
          // console.log('CTRL + SHIFT + K FIRED');
          document
            .querySelector('[data-hotkey="patient-search"]')
            ?.dispatchEvent(new CustomEvent('open-search'));
        },
        'Open Patient Search',
        true
      );

      this.hotkeyService.addShortcut(
        'control.q',
        () => {
          // console.log('CTRL + SHIFT + K FIRED');
          document
            .querySelector('[data-hotkey="patient-search"]')
            ?.dispatchEvent(new CustomEvent('open-queue'));
        },
        'Open Consultation Queue',
        true
      );

      this.hotkeyService.addShortcut(
        'control.m',
        () => {
          // console.log('CTRL + SHIFT + K FIRED');
          document
            .querySelector('[data-hotkey="patient-search"]')
            ?.dispatchEvent(new CustomEvent('open-medicine-queue'));
        },
        'Open Quick Prescription Dialog',
        true
      );

      this.hotkeyService.addShortcut(
        'escape',
        () => {
          document
            .querySelector('p-sidebar .p-sidebar-close')
            ?.dispatchEvent(new Event('click'));
        },
        'Close Sidebar / Modal',
        true
      );

      this.hotkeyService.addShortcut(
        'alt.a',
        () => this.router.navigate(['/admin/appointment']),
        'Go to Appointments'
      );

      this.hotkeyService.addShortcut(
        'alt.l',
        () => this.router.navigate(['/admin/appointment-list']),
        'Go to Appointment List'
      );

      this.hotkeyService.addShortcut(
        'alt.k',
        () => this.router.navigate(['/admin/appointment-kanban']),
        'Go to Appointment Kanban'
      );

      this.hotkeyService.addShortcut(
        'alt.x',
        () => this.router.navigate(['/admin/prescriptions']),
        'Go to Prescriptions'
      );

      this.hotkeyService.addShortcut(
        'alt.p',
        () => this.router.navigate(['/admin/patient-registration']),
        'Go to Patient Registration'
      );

      this.hotkeyService.addShortcut(
        'alt.m',
        () => this.router.navigate(['/admin/pharmacy']),
        'Go to Dispense Medicine'
      );

      this.hotkeyService.addShortcut(
        'alt.shift.m',
        () => this.router.navigate(['/admin/medicine']),
        'Go to Manage Medicine'
      );

      this.hotkeyService.addShortcut(
        'alt.b',
        () => this.router.navigate(['/admin/bills']),
        'Go to Bills'
      );

      this.hotkeyService.addShortcut(
        'alt.c',
        () => this.router.navigate(['/admin/certificates']),
        'Go to Certificates'
      );

      this.hotkeyService.addShortcut(
        'alt.f',
        () => this.router.navigate(['/admin/medicine-finder']),
        'Go to Medicine Finder'
      );

      this.hotkeyService.addShortcut(
        'shift.r',
        () => this.router.navigate(['/admin/analytics-collections']),
        'Go to Analytics Collections'
      );
    }

    //! ========================= ASSISTANT DOCTOR

    if (this.userRole === 'assistant_doctor') {

      this.hotkeyService.addShortcut(
        'control.shift.f',
        () => {
          // console.log('CTRL + SHIFT + K FIRED');
          document
            .querySelector('[data-hotkey="patient-search"]')
            ?.dispatchEvent(new CustomEvent('open-search'));
        },
        'Open Patient Search',
        true
      );

      this.hotkeyService.addShortcut(
        'alt.m',
        () => this.router.navigate(['/admin/pharmacy']),
        'Dispense Medicine'
      );

      this.hotkeyService.addShortcut(
        'alt.p',
        () => this.router.navigate(['/admin/patient-registration']),
        'Patient Registration'
      );

      this.hotkeyService.addShortcut(
        'alt.f',
        () => this.router.navigate(['/admin/medicine-finder']),
        'Medicine Finder'
      );

      this.hotkeyService.addShortcut(
        'alt.c',
        () => this.router.navigate(['/admin/certificates']),
        'Certificates'
      );
    }

    //! ========================= RECEPTION

    if (this.userRole === 'reception') {

      this.hotkeyService.addShortcut(
        'control.q',
        () => {
          // console.log('CTRL + SHIFT + K FIRED');
          document
            .querySelector('[data-hotkey="patient-search"]')
            ?.dispatchEvent(new CustomEvent('open-queue'));
        },
        'Open Consultation Queue',
        true
      );

      this.hotkeyService.addShortcut(
        'control.m',
        () => {
          // console.log('CTRL + SHIFT + K FIRED');
          document
            .querySelector('[data-hotkey="patient-search"]')
            ?.dispatchEvent(new CustomEvent('open-medicine-queue'));
        },
        'Open Medicine Queue',
        true
      );

      this.hotkeyService.addShortcut(
        'escape',
        () => {
          document
            .querySelector('p-sidebar .p-sidebar-close')
            ?.dispatchEvent(new Event('click'));
        },
        'Close Sidebar / Modal',
        true
      );

      this.hotkeyService.addShortcut(
        'alt.a',
        () => this.router.navigate(['/admin/appointment']),
        'Appointment Calendar'
      );

      this.hotkeyService.addShortcut(
        'alt.l',
        () => this.router.navigate(['/admin/appointment-list']),
        'Appointment List'
      );

      this.hotkeyService.addShortcut(
        'alt.k',
        () => this.router.navigate(['/admin/appointment-kanban']),
        'Appointment Kanban'
      );

      this.hotkeyService.addShortcut(
        'alt.p',
        () => this.router.navigate(['/admin/patient-registration']),
        'Patient Registration'
      );

      this.hotkeyService.addShortcut(
        'alt.m',
        () => this.router.navigate(['/admin/pharmacy']),
        'Dispense Medicine'
      );

      this.hotkeyService.addShortcut(
        'alt.c',
        () => this.router.navigate(['/admin/certificates']),
        'Certificates'
      );
    }

    //! ========================= PHARMACY

    if (this.userRole === 'pharmacy') {

      this.hotkeyService.addShortcut(
        'alt.shift.m',
        () => this.router.navigate(['/admin/medicine']),
        'Manage Medicine'
      );
    }
  }


  /* =========================
     MENU CONFIGURATION
     ========================= */

  private configureMenus(loggedInUser: any) {
    try {
      const menus: any[] = this.common.getMenu();
      this.common.isEmailadminLogin = true;

      if (loggedInUser.type === 'reception') {
        menus.splice(0, 3);
        menus.push(
          {
            title: 'Appointments',
            icon1: 'home',
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>`,
            isActive: true,
            items: [
              { title: 'Appointment Calendar', icon1: 'home', icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>`, path: '/admin/appointment' },
              { title: 'Appointment List', icon1: 'home', icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>`, path: '/admin/appointment-list' },
            ],
          },
          {
            title: 'Patients',
            icon1: 'home',
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>`,
            isActive: true,
            items: [
              { title: 'Patient Registration', icon1: 'home', icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/></svg>`, path: '/admin/patient-registration' },
            ],
          }
        );
      }

      else if (loggedInUser.type === 'assistant_doctor') {
        menus.splice(0, 3);
        menus.push({
          title: 'Patients',
          icon1: 'home',
          icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>`,
          isActive: true,
          items: [
            { title: 'Pre Consultation', icon1: 'home', icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1" ry="1"/></svg>`, path: '/admin/pre-consultation' },
            { title: 'Patient Registration', icon1: 'home', icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/></svg>`, path: '/admin/patient-registration' },
          ],
        });
      }

      else if (loggedInUser.type === 'doctor') {
        menus.splice(0, 2);
        menus.push(
          {
            title: 'Appointments',
            icon1: 'home',
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>`,
            isActive: true,
            items: [
              { title: 'Appointment Calendar', icon1: 'home', icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>`, path: '/admin/appointment' },
              { title: 'Appointment List', icon1: 'home', icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>`, path: '/admin/appointment-list' },
            ],
          },
          {
            title: 'Patients',
            icon1: 'home',
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>`,
            isActive: true,
            items: [
              { title: 'Prescriptions', icon1: 'home', icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>`, path: '/admin/prescriptions' },
              { title: 'Patient Registration', icon1: 'home', icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/></svg>`, path: '/admin/patient-registration' },
            ],
          },
          {
            title: 'Pharmacy',
            icon1: 'home',
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z"/><path d="m8.5 8.5 7 7"/></svg>`,
            isActive: true,
            items: [
              { title: 'Dispense Medicine', icon1: 'home', icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m18 2 4 4"/><path d="m17 7 3-3"/><path d="M19 9 8.7 19.3c-1 1-2.5 1-3.4 0l-.6-.6c-1-1-1-2.5 0-3.4L15 5"/><path d="m9 11 4 4"/><path d="m5 19-3 3"/><path d="m14 4 6 6"/></svg>`, path: '/admin/pharmacy' },
              { title: 'Manage Medicine', icon1: 'home', icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>`, path: '/admin/medicine' },
            ],
          }
        );
      }

      else if (loggedInUser.type === 'pharmacy') {
        menus.splice(0, 3);
        menus.push({
          title: 'Pharmacy',
          icon1: 'home',
          icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z"/><path d="m8.5 8.5 7 7"/></svg>`,
          isActive: true,
          items: [
            { title: 'Dispense Medicine', icon1: 'home', icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m18 2 4 4"/><path d="m17 7 3-3"/><path d="M19 9 8.7 19.3c-1 1-2.5 1-3.4 0l-.6-.6c-1-1-1-2.5 0-3.4L15 5"/><path d="m9 11 4 4"/><path d="m5 19-3 3"/><path d="m14 4 6 6"/></svg>`, path: '/admin/pharmacy' },
            { title: 'Manage Medicine', icon1: 'home', icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>`, path: '/admin/medicine' },
          ],
        });
      }

      this.common.setProductOwner('Dr. Shailesh Sancheti Clinic');
      this.common.setMenu(menus);
      this.common.navBarPos = 'special-horizontal-wrapper';
    } catch { }
  }

  /* =========================
     ENV CONFIG
     ========================= */

  private configureEnvironment() {
    this.common.setBaseUrl(`${environment.apiUrl}/`);
    this.sso.setLoginApiUrl(`${environment.apiUrl}/login`);
  }

  /* =========================
     LOGO REPLACEMENT
     ========================= */

  ngAfterViewInit() {
    this.ensureNavbarLogo();

    this.logoObserver = new MutationObserver(() => {
      this.ensureNavbarLogo();
    });

    this.logoObserver.observe(document.body, { childList: true, subtree: true });
  }

  ngOnDestroy(): void {
    if (this.logoObserver) {
      this.logoObserver.disconnect();
      this.logoObserver = null;
    }
  }

  private ensureNavbarLogo() {
    const anchor = document.querySelector('.header-logo-wrapper a');
    if (!anchor) return;

    const existing = anchor.querySelector('img.app-navbar-logo') as HTMLImageElement | null;
    const heading = anchor.querySelector('h2');

    if (!existing) {
      const logo = document.createElement('img');
      logo.className = 'app-navbar-logo';
      logo.src = '/clinic/logo.png';
      // logo.src = '/logo.png';
      logo.alt = 'Dr. Sancheti Logo';
      logo.style.height = '45px';
      logo.style.objectFit = 'contain';
      logo.style.maxWidth = '220px';

      if (heading) {
        heading.replaceWith(logo);
      } else {
        anchor.prepend(logo);
      }
      return;
    }

    if (existing.getAttribute('src') !== '/clinic/logo.png') {
      existing.setAttribute('src', '/clinic/logo.png');
    }

    if (heading) {
      heading.remove();
    }
  }
}
